/**
 * FilterChips — All / Manual / PreachKit / Songs chips above the project grid.
 * Counts are computed in the parent (Dashboard) since they depend on the
 * projects array + source heuristic.
 */
export default function FilterChips({ t, value, onChange, counts }) {
  const chips = [
    { key: "all",        label: t("filter_all")        || "All",       count: counts.all },
    { key: "manual",     label: t("filter_manual")     || "Manual",    count: counts.manual },
    { key: "preach_kit", label: t("filter_preach_kit") || "PreachKit", count: counts.preach_kit },
    { key: "songs",      label: t("filter_songs")      || "Songs",     count: counts.songs },
  ];
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="project-filter-chips">
      {chips.map((chip) => (
        <button
          key={chip.key}
          onClick={() => onChange(chip.key)}
          disabled={chip.count === 0 && chip.key !== "all"}
          data-testid={`filter-chip-${chip.key}`}
          className={`px-3 py-1 text-xs rounded-full border transition-colors ${
            value === chip.key
              ? "bg-amber-500 border-amber-500 text-white"
              : "bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:bg-amber-500/10 hover:border-amber-500/40"
          } disabled:opacity-40 disabled:cursor-not-allowed`}
        >
          {chip.label}
          <span className="ml-1.5 opacity-70">{chip.count}</span>
        </button>
      ))}
    </div>
  );
}
